export default __webpack_public_path__ + "static/media/Tackle Mount.901ef0f8.png";